import React from 'react';
import { Route } from './Route';
import { generatePath } from 'react-router';
import history from '@app/lib/history';
import queryString from 'query-string';
import { RouteProps } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

export interface LocationOptions<Params = {}, QueryParams = {}> {
  path: string;
  component?: React.ComponentType<any>;
  resolveUrl?: (
    baseUrl: string,
    params?: Params,
    queryParams?: QueryParams
  ) => any;
  redirect?: {
    when: (sessionStore) => boolean;
    to: (sessionStore) => string;
  };
}

export class Location<Params = {}, QueryParams = {}> {
  constructor(private options: LocationOptions<Params>) {}

  getUrl(params?: Params, queryParams?: QueryParams) {
    if (this.options.resolveUrl)
      return this.options.resolveUrl(this.options.path, params, queryParams);
    let url = generatePath(this.options.path, params || {});
    const query = queryString.stringify(queryParams || {});
    if (query !== '') {
      url += `?${query}`;
    }
    return url;
  }

  go(params?: Params, queryParams?: QueryParams) {
    history.push(this.getUrl(params, queryParams));
  }

  getRouteComponent(props: RouteProps & { key?: any } = {}, sessionStore = {}) {
    if (this.options.redirect) {
      return (
        <ProtectedRoute
          path={this.options.path}
          component={this.options.component}
          when={this.options.redirect.when(sessionStore)}
          redirectTo={this.options.redirect.to(sessionStore)}
          {...props}
        />
      );
    }
    return (
      <Route
        path={this.options.path}
        component={this.options.component}
        exact
        {...props}
      />
    );
  }
}
